<div class="search-form px-0"
  *ngIf="{vehicle: serviceLaneFacade.vehicle$ | async, associate: serviceLaneFacade.customerAssociate$ | async, address: serviceLaneFacade.customerAddress$ | async, bodyDropdowns: bodyDropdowns$ | async} as data">
  <div class="flex place-content-between place-items-start mt-2.5" *ngIf="data.vehicle">
    <div class="flex flex-col mb-1.5">
      <h1 class="font-medium mb-0">
        {{data.vehicle.year + ' ' + data.vehicle.make + ' ' + data.vehicle.model}}</h1>
      <div class="flex place-content-start place-items-center text-gray-600">
        <span class="mat-body-2">ID:{{data.vehicle.id}}</span>
        <span class="mt-0 mb-0 ml-1 mr-1 text-2xl font-medium">·</span>
        <span class="mat-body-2">Owned by
          {{data?.vehicle?.embedded?.associate?.firstName}} {{data?.vehicle?.embedded?.associate?.lastName}}</span>
      </div>
    </div>

    <button *ngIf="!editMode;else editModeButtons" mat-icon-button color="primary"
      [disabled]="!data.associate || !data.address"
      (click)="enableEditMode(data.vehicle, data.associate, data.address)">
      <mat-icon>edit</mat-icon>
    </button>

    <ng-template #editModeButtons>
      <div class="flex flex-col">
        <div>
          <button class="cancel-button" mat-icon-button (click)="editMode = !editMode">
            <mat-icon
              [ngClass]="{'cancel-icon-unsaved': associateForm.dirty || addressForm.dirty || vehicleForm.dirty}">
              cancel</mat-icon>
          </button>
          <button mat-icon-button
            (click)="updateFormResources(vehicleForm.value, associateForm.value, addressForm.value)" class="save-button"
            [ngClass]="{'save-button--disabled': addressForm.invalid || vehicleForm.invalid || associateForm.invalid}">
            <mat-icon class="save-icon"
              [ngClass]="{'save-icon--disabled': addressForm.invalid || vehicleForm.invalid || associateForm.invalid}">
              save
            </mat-icon>
          </button>
        </div>

        <div class="flex flex-row unsaved-div"
          [ngClass]="{'cancel-icon-unsaved': associateForm.dirty || addressForm.dirty || vehicleForm.dirty}"
          *ngIf="(associateForm && addressForm && vehicleForm) && (associateForm.dirty || addressForm.dirty || vehicleForm.dirty)">
          Unsaved Changes
        </div>
      </div>
    </ng-template>
  </div>

  <mat-divider class="mb-2"></mat-divider>
  <svc-vehicle-card *ngIf="!editMode && data.vehicle;else editVehicleContainer" [vehicleId]="data.vehicle.id"
    [vin]="data.vehicle.vin" [associate]="data.associate">
  </svc-vehicle-card>

  <ng-template #editVehicleContainer>
    <div *ngIf="data.vehicle">
      <div
        *ngIf="{ vehicleDropdowns: serviceLaneDropdownFacade.vehicleDropdowns$ | async, associateDropdowns:serviceLaneDropdownFacade.associateDropdowns$ | async, addressDropdowns: serviceLaneDropdownFacade.addressDropdowns$ | async} as dropdownData">
        <h3 class="font-medium">Associate</h3>
        <form id="associateForm" class="flex flex-row flex-wrap place-content-start place-items-center form-container"
          [formGroup]="associateForm" novalidate>

          <div class="flex flex-row place-content-center place-items-center form-field" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Email Address</mat-label>
              <input id="emailAddress" matInput formControlName="emailAddress">
              <mat-error *ngIf="associateForm.get('emailAddress').errors">
                {{associateForm.get('emailAddress').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-row place-content-center place-items-center form-field" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Message Preference</mat-label>
              <mat-select name="messagePreferenceId" formControlName="messagePreferenceId">
                <mat-option *ngFor="let messageType of dropdownData.associateDropdowns.messageTypes"
                  [value]="messageType.id">
                  {{messageType.description}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>

        <h3 class="font-medium">Address</h3>
        <form id="addressForm" class="flex flex-row flex-wrap place-content-start place-items-center form-container"
          [formGroup]="addressForm" novalidate>

          <div class="flex flex-row place-content-center place-items-center form-field" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Address Line</mat-label>
              <input id="addressLine1" matInput formControlName="addressLine1">
            </mat-form-field>
          </div>

          <div class="form-field flex flex-row place-content-center place-items-center" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Province/State</mat-label>
              <mat-select name="provStateId" formControlName="provStateId" required>
                <mat-option *ngFor="let provinceState of dropdownData.addressDropdowns.provinceStates"
                  [value]="provinceState.id">

                  {{ provinceState.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-row place-content-center place-items-center form-field" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Location</mat-label>
              <mat-select #location name="locationId" formControlName="locationId" required>
                <mat-option *ngFor="let location of locations$ | async" [value]="location.id">
                  {{location.description}} {{location.provStateId}}, {{location.countryId}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-row place-content-center place-items-center form-field" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Postal/Zip Code</mat-label>
              <input id="postalZipCode" matInput formControlName="postalZipCode">
            </mat-form-field>
          </div>

          <div class="flex flex-row place-content-center place-items-center form-field" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Cell Phone</mat-label>
              <input id="cellPhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
                formControlName="cellPhoneNumber">
              <mat-error *ngIf="addressForm.get('cellPhoneNumber').errors">
                {{addressForm.get('cellPhoneNumber').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-row place-content-center place-items-center form-field" fxFlex.sm="33"
            fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Home Phone</mat-label>
              <input id="homePhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
                formControlName="homePhoneNumber">
            </mat-form-field>
          </div>
        </form>

        <h3 class="font-medium">Vehicle</h3>
        <form id="vehicleForm" class="flex flex-row flex-wrap place-content-start place-items-center"
          [formGroup]="vehicleForm" novalidate>
          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label> Owner Name (Last, First)</mat-label>
              <input #associateName matInput autocomplete="dank" id="dank" aria-label="Associate"
                [matAutocomplete]="auto" formControlName="name" (change)="saveTypedName($event.target.value)"
                #trigger="matAutocompleteTrigger">
              <mat-autocomplete #auto="matAutocomplete" autocomplete="dank"
                [displayWith]="displayAssociateName.bind(auto,filteredAssociates)"
                (optionSelected)="selectAssociate($event.option.value,filteredAssociates, data.associate )">
                <mat-option value="addAssociate">-- Add Associate --</mat-option>
                <mat-option *ngFor="let associate of filteredAssociates" [value]="associate.id">
                  <span>{{associate.nameAddress}}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Year</mat-label>
              <input id="year" matInput formControlName="year">
              <mat-error
                *ngIf="vehicleForm.get('year').hasError('pattern') || vehicleForm.get('year').hasError('minlength') || vehicleForm.get('year').hasError('maxlength')">
                Year must be a 4 digit number.</mat-error>
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Make</mat-label>
              <mat-select formControlName="make">
                <mat-option *ngFor="let make of dropdownData.vehicleDropdowns.makes" [value]="make.description">
                  {{make.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Model</mat-label>
              <input id="model" matInput formControlName="model">
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Body</mat-label>
              <input #vehicleBody matInput autocomplete="vehicleBody" id="vehicleBody" aria-label="Body"
                [matAutocomplete]="vehicleBodyAuto" formControlName="body">
              <mat-autocomplete #vehicleBodyAuto="matAutocomplete" autocomplete="vehicleBody">
                <mat-option *ngFor="let body of data.bodyDropdowns" [value]="body.vehicleBody">
                  <span>{{body.vehicleBody}}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Vin</mat-label>
              <input id="vin" matInput formControlName="vin" oninput="this.value = this.value.toUpperCase()">
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Engine</mat-label>
              <input id="engine" matInput formControlName="engine">
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Plate Number</mat-label>
              <input id="licensePlateNumber" matInput formControlName="licensePlateNumber"
                oninput="this.value = this.value.toUpperCase()">
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Current Mileage</mat-label>
              <input id="currentMileage" matInput formControlName="currentMileage">
              <mat-error *ngIf="vehicleForm.get('currentMileage').hasError('pattern')">
                Mileage must be a number.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>Prospect Colour</mat-label>
              <mat-select formControlName="prospectColourId">
                <mat-option *ngFor="let colour of dropdownData.vehicleDropdowns.colours" [value]="colour.id">
                  {{colour.colourDescription}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
            <mat-form-field appearance="fill">
              <mat-label>In-Service Date</mat-label>
              <input [matDatepicker]="deliveryDatePicker" id="deliveryDate" matInput formControlName="deliveryDate">
              <mat-error *ngIf="vehicleForm.get('deliveryDate').hasError('matDatepickerParse')">
                Must be a valid date.
              </mat-error>
              <mat-datepicker-toggle matSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #deliveryDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
</div>
<div class="search-form" [ngClass]="{ 'hidden': editMode }">
  <mat-divider class="mt-3"></mat-divider>
  <div
    *ngIf="{openAppointments: openAppointments$ | async, systemControls: systemControl$ | async, vehicle: serviceLaneFacade.vehicle$ | async, employee: authenicatedEmployee$ | async, customerAssociate: serviceLaneFacade.customerAssociate$ | async} as data2">
    <div *ngIf="!displayNewAppointmentForm else newAppointmentHeader;" class="flex flex-col">
      <div class="flex place-content-between place-items-start">
        <h2>Appointments</h2>
        <button mat-icon-button color="primary"
          (click)="toggleAppointmentForm(data2.vehicle,data2.customerAssociate,displayNewAppointmentForm,data2.systemControls,data2.employee)">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
      <mat-nav-list>
        <mat-list-item (click)="openAppointment(appointment)"
          *ngFor="let appointment of data2.openAppointments;index as i">
          <div mat-list-icon class="icon-container">
            <mat-icon>date_range</mat-icon>
          </div>
          <h3 mat-line>{{appointment.dateTime | moment: 'dddd, MMMM Do YYYY, h:mm:ss a'}}</h3>
          <div class="delete-icon-container">
            <button mat-icon-button (click)="deleteAppointment(appointment, $event)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <p mat-line *ngIf="appointment?.embedded?.serviceAdvisorAssociate">
            {{appointment?.embedded?.serviceAdvisorAssociate?.firstName + ' ' +
            appointment?.embedded?.serviceAdvisorAssociate?.lastName }}
          </p>
          <mat-divider inset *ngIf="i+1 < data2.openAppointments.length"></mat-divider>
        </mat-list-item>
      </mat-nav-list>
    </div>
    <ng-template #newAppointmentHeader>
      <div class="flex flex-col">
        <div class="flex place-content-between place-items-center">
          <h2>New</h2>
          <div>
            <button mat-icon-button class="secondary cancel-button"
              (click)="cancelNewAppointment(displayNewAppointmentForm)">
              <mat-icon>cancel</mat-icon>
            </button>
            <button mat-icon-button color="secondary" class="save-button" [disabled]="appointmentFormInvalid$ | async"
              (click)="createAppointment(appointmentForm.getRawValue())">
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
        <sha-service-appointment-form [appointment$]="newAppointment$"
          [appointmentDropdowns$]="serviceAppointmentDropdowns$" [vehicle]="data2.vehicle"
          (appointmentFormEmit)="appointmentFormEmit($event)">
        </sha-service-appointment-form>
      </div>
    </ng-template>
  </div>
</div>